












import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';

@Component
export default class Overlay extends Vue  {
  @Prop({default:false,type:Boolean}) readonly show!:boolean
  @Prop({default:0,type:Number}) readonly  duration!:number
  @Prop({default:'body',type:String}) readonly  container!:string
  @Prop(String) readonly animation!:string

  onClick(e:Event){
    this.$emit('click',e)
  }


}
